export default __webpack_public_path__ + "fd88855b8c45c5b0f8f43a3cf7c82b62.png";